import $foreign from "./foreign.cjs";
var abs = $foreign.abs;
var acos = $foreign.acos;
var asin = $foreign.asin;
var atan = $foreign.atan;
var atan2 = $foreign.atan2;
var ceil = $foreign.ceil;
var cos = $foreign.cos;
var e = $foreign.e;
var exp = $foreign.exp;
var floor = $foreign.floor;
var imul = $foreign.imul;
var ln10 = $foreign.ln10;
var ln2 = $foreign.ln2;
var log = $foreign.log;
var log10e = $foreign.log10e;
var log2e = $foreign.log2e;
var max = $foreign.max;
var min = $foreign.min;
var pi = $foreign.pi;
var pow = $foreign.pow;
var remainder = $foreign.remainder;
var round = $foreign.round;
var sin = $foreign.sin;
var sqrt = $foreign.sqrt;
var sqrt1_2 = $foreign.sqrt1_2;
var sqrt2 = $foreign.sqrt2;
var tan = $foreign.tan;
var tau = $foreign.tau;
var trunc = $foreign.trunc;
export { abs, acos, asin, atan, atan2, ceil, cos, e, exp, floor, imul, ln10, ln2, log, log10e, log2e, max, min, pi, pow, remainder, round, sin, sqrt, sqrt1_2, sqrt2, tan, tau, trunc };
